import { ArrowDecisionAutoOutlineIcon } from './ArrowDecisionAutoOutlineIcon';

/**
 * author: Michael Richins
 * id FA34CDF8-9B5D-40D2-97D5-00F41438A185
 * name arrow-decision-auto-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-decision-auto-outline.svg
 * tags
 */
export const ProxyAutoOutlineIcon = ArrowDecisionAutoOutlineIcon;
export default ProxyAutoOutlineIcon